export default __webpack_public_path__ + "static/media/OneStar.8bd789d9.svg";